<template>
    <div ref="content">
        <div class="bg_box bg_01">
            <rule_button class="rule_button" @alter="alter" @knapsack="update_alter" @init="init"></rule_button>
            <a href="/" class="logo">
                <div class="img_02"></div>
            </a>

        </div>
        <div class="bg_box bg_02">
            <div class="move_button">
                <div class="201 center cursor" style="margin-bottom: .1rem" @click="alter('show_probability')"></div>
                <div class="center text img_202" style="margin-bottom: .1rem"></div>

                <div class="img_201 center cursor" style="margin-bottom: .1rem"
                     @click="alter('show_probability')"></div>
                <div class="lottery center">
                    <div :class="user.value>=1?'img_03 cursor inline':'img_03 cursor inline'" @click="lottery(1)"></div>
                    <div :class="user.value>=5?'img_04 cursor inline':'img_04 cursor inline'" @click="lottery(5)"></div>
                </div>
                <div class=" center text" style="margin-bottom: .1rem"> 剩余抽奖次数:{{ user.value }}</div>
                <div class="img_18 center cursor" style="margin-bottom: .1rem" @click="update_alter()"></div>
            </div>
        </div>
        <div class="bg_box bg_03"></div>

        <div class="bg_box bg_04">
            <!--            任务           -->
            <div class="task_box">
                <div v-for="item,key in task" @click="go_task(item)" :class="'task_item ' + item.task_id">
                    <div :class="item.val < item.max_val? item.class + ' cursor ':' img_01 '"></div>
                    <div v-show="item.max_val>1" class="img_11 progressBar">
                        <div class="img_10" :style="{width:parseInt(item.val*100/item.max_val)+'%'}"></div>
                        <div class="" v-text="item.val+'/'+item.max_val"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg_box bg_05">
            <!--            背包              -->
            <div class="config_box">
                <div v-for="item,key in config" :class="'img_nk_0 ico_bg '+ (key==0?' img_nk_0 ':' img_nk_1 ')"
                     @click="update_alter()">
                    <div class="img_214 left_bottom " v-if="(item.item_id>0&&item.item_id<7)||item.item_id===0"></div>
                    <div class="img_19 ico_img " v-if="item.lock"></div>
                    <div :class="' ico_img ico_'+item.item_id" v-else></div>
                    <div class="text_name" v-text="conf_name[item.item_id]"></div>
                    <div class=" update_alter"></div>
                </div>
                <div class="lock img_07 cursor" v-if="!user.config_is_lock" @click="update_alter()"></div>
                <div class="lock img_20" v-else></div>
            </div>

        </div>
        <div class="bg_box bg_06"></div>
        <div class="bg_box bg_07"></div>
    </div>
</template>

<script>
var img_list = [
    require('../img/lottery/0.png'),
    require('../img/lottery/1.png'),
    require('../img/lottery/2.png'),
    require('../img/lottery/3.png'),
    require('../img/lottery/4.png'),
    require('../img/lottery/5.png'),
    require('../img/lottery/6.png'),

    require('../img/ico/ico_0.png'),
    require('../img/ico/ico_1.png'),
    require('../img/ico/ico_2.png'),
    require('../img/ico/ico_3.png'),
    require('../img/ico/ico_4.png'),
    require('../img/ico/ico_5.png'),
    require('../img/ico/ico_6.png'),
    require('../img/ico/ico_7.png'),
    require('../img/ico/ico_8.png'),
    require('../img/ico/ico_9.png'),
    require('../img/ico/ico_10.png'),
    require('../img/ico/ico_11.png'),
    require('../img/ico/ico_12.png'),
    require('../img/ico/ico_13.png'),


    require("../img/10.png"),
    require("../img/09.png"),
    require("../img/11.png"),
    require("../img/17.png"),
    require("../img/221.png"),
    require("../img/01.png"),
    require("../img/13.png"),
    require("../img/15.png"),
    require("../img/16.png"),
    require("../img/02.png"),
    require("../img/08.png"),
    require("../img/12.png"),
    require("../img/18.png"),
    require("../img/19.png"),
    require("../img/14.png"),
    require("../img/07.png"),
    require("../img/03.png"),
    require("../img/04.png"),
    require("../img/bg_05.jpg"),
    require("../img/bg_06.jpg"),
    require("../img/bg_04.jpg"),
    require("../img/bg_01.jpg"),
    require("../img/bg_02.jpg"),
    require("../img/bg_03.jpg"),
    require('../img/67.png'),
    require('../img/68.png'),
    require('../img/38.png'),
    require('../img/66.png'),
    require('../img/90.png'),
    require('../img/60.png'),
    require('../img/59.png'),
    require('../img/61.png'),
    require('../img/32.png'),
    require('../img/33.png'),
    require('../img/55.png'),
    require('../img/56.png'),
    require('../img/43.png'),
    require('../img/44.png'),
    require('../img/45.png'),
    require('../img/40.png'),
    require('../img/41.png'),
    require('../img/42.png'),
    require('../img/52.png'),
    require('../img/54.png'),
    require('../img/53.png'),
    require('../img/48.png'),
    require('../img/46.png'),
    require('../img/51.png'),
    require('../img/57.png'),
    require('../img/47.png'),
    require('../img/64.png'),
    require('../img/30.png'),
    require('../img/62.png'),
    require('../img/65.png'),
    require('../img/35.png'),
    require('../img/34.png'),
    require('../img/39.png'),
    require('../img/58.png'),
    require('../img/89.png'),
    require('../img/91.png'),
    require('../img/92.png'),
    require('../img/93.jpg'),
    require('../img/95.png'),
    require('../img/96.png'),
    require('../img/100.png'),
    require('../img/101.png'),
    require('../img/102.png'),
    require('../img/201.png'),
    require('../img/203.png'),
    require('../img/214.png'),
    require('../img/215.png'),
    require('../img/ico/ico_0.png'),
    require('../img/ico/ico_1.png'),
    require('../img/ico/ico_2.png'),
    require('../img/ico/ico_3.png'),
    require('../img/ico/ico_4.png'),
    require('../img/ico/ico_5.png'),
    require('../img/ico/ico_6.png'),
    require('../img/ico/ico_7.png'),
    require('../img/ico/ico_8.png'),
    require('../img/ico/ico_9.png'),
    require('../img/ico/ico_10.png'),
    require('../img/ico/ico_11.png'),
    require('../img/ico/ico_12.png'),
    require('../img/ico/ico_13.png'),
    require('../img/ico/ico_13.png'),

    require('../img/lottery/show/1.jpg'),
    require('../img/lottery/show/2.jpg'),
    require('../img/lottery/show/3.jpg'),
    require('../img/lottery/show/4.jpg'),
    require('../img/lottery/show/5.jpg'),
    require('../img/lottery/show/6.jpg'),
    require('../img/lottery/show/7.jpg'),
    require('../img/lottery/show/8.jpg'),
    require('../img/lottery/show/9.jpg'),
    require('../img/lottery/show/10.jpg'),
    require('../img/lottery/show/11.jpg'),
    require('../img/lottery/show/12.jpg'),
    require('../img/lottery/show/13.jpg'),
    require('../img/lottery/show/14.jpg'),
    require('../img/lottery/show/15.jpg'),
    require('../img/lottery/show/16.jpg'),
    require('../img/lottery/show/17.jpg'),
    require('../img/lottery/show/18.jpg'),
    require('../img/lottery/show/19.jpg'),
    require('../img/lottery/show/20.jpg'),
    require('../img/lottery/show/21.jpg'),
    require('../img/lottery/show/22.jpg'),
    require('../img/lottery/show/23.jpg'),
    require('../img/lottery/show/24.jpg'),
    require('../img/lottery/show/25.jpg'),
    require('../img/lottery/show/26.jpg'),
    require('../img/lottery/show/27.jpg'),
    require('../img/lottery/show/28.jpg'),
    require('../img/lottery/show/29.jpg'),
    require('../img/lottery/show/30.jpg'),
    require('../img/lottery/show/31.jpg'),
    require('../img/lottery/show/32.jpg'),
    require('../img/lottery/show/33.jpg'),
    require('../img/lottery/show/34.jpg'),
    require('../img/lottery/show/35.jpg'),
    require('../img/lottery/show/36.jpg'),
    require('../img/lottery/show/37.jpg'),
    require('../img/lottery/show/38.jpg'),
    require('../img/lottery/show/39.jpg'),
    require('../img/lottery/show/40.jpg'),
    require('../img/lottery/show/41.jpg'),
    require('../img/lottery/show/42.jpg'),
    require('../img/lottery/show/43.jpg'),
    require('../img/lottery/show/44.jpg'),
    require('../img/lottery/show/45.jpg'),
    require('../img/lottery/show/46.jpg'),
    require('../img/lottery/show/47.jpg'),
    require('../img/lottery/show/48.jpg'),
    require('../img/lottery/show/49.jpg'),
    require('../img/lottery/show/50.jpg'),
    require('../img/lottery/show/51.jpg'),
    require('../img/lottery/show/52.jpg'),
    require('../img/lottery/show/53.jpg'),
    require('../img/lottery/show/54.jpg'),
    require('../img/lottery/show/55.jpg'),
    require('../img/lottery/show/56.jpg'),
    require('../img/lottery/show/57.jpg'),
    require('../img/lottery/show/58.jpg'),
    require('../img/lottery/show/59.jpg'),
    require('../img/lottery/show/60.jpg'),
    require('../img/lottery/show/61.jpg'),
    require('../img/lottery/show/62.jpg'),
    require('../img/lottery/show/63.jpg'),
    require('../img/lottery/show/64.jpg'),
    require('../img/lottery/show/65.jpg'),
    require('../img/lottery/show/66.jpg'),
    require('../img/lottery/show/67.jpg'),
    require('../img/lottery/show/68.jpg'),
    require('../img/lottery/show/69.jpg'),
    require('../img/lottery/show/70.jpg'),
    require('../img/lottery/show/71.jpg'),
    require('../img/lottery/show/72.jpg'),
    require('../img/lottery/show/73.jpg'),
    require('../img/lottery/show/74.jpg'),
    require('../img/lottery/show/75.jpg'),
    require('../img/lottery/show/76.jpg'),
    require('../img/lottery/show/77.jpg'),

    require('../img/lottery/card_show/1.png'),
    require('../img/lottery/card_show/2.png'),
    require('../img/lottery/card_show/3.png'),
    require('../img/lottery/card_show/4.png'),
    require('../img/lottery/card_show/5.png'),
    require('../img/lottery/card_show/6.png'),
    require('../img/lottery/card_show/7.png'),
    require('../img/lottery/card_show/8.png'),
    require('../img/lottery/card_show/9.png'),
    require('../img/lottery/card_show/10.png'),
    require('../img/lottery/card_show/11.png'),
    require('../img/lottery/card_show/12.png'),
    require('../img/lottery/card_show/13.png'),
    require('../img/lottery/card_show/14.png'),
    require('../img/lottery/card_show/15.png'),
    require('../img/lottery/card_show/16.png'),
    require('../img/lottery/card_show/17.png'),
    require('../img/lottery/card_show/18.png'),
    require('../img/lottery/card_show/19.png'),
    require('../img/lottery/card_show/20.png'),
    require('../img/lottery/card_show/21.png'),
    require('../img/lottery/card_show/22.png'),
    require('../img/lottery/card_show/23.png'),
    require('../img/lottery/card_show/24.png'),
    require('../img/lottery/card_show/25.png'),
    require('../img/lottery/card_show/26.png'),
    require('../img/lottery/card_show/27.png'),
    require('../img/lottery/card_show/28.png'),
    require('../img/lottery/card_show/29.png'),

    require('../img/lottery/card_show/30.png'),
    require('../img/lottery/card_show/31.png'),
    require('../img/lottery/card_show/32.png'),
    require('../img/lottery/card_show/33.png'),
    require('../img/lottery/card_show/34.png'),
    require('../img/lottery/card_show/35.png'),
    require('../img/lottery/card_show/36.png'),
    require('../img/lottery/card_show/37.png'),
    require('../img/lottery/card_show/38.png'),
    require('../img/lottery/card_show/39.png'),

    require('../img/lottery/card_show/40.png'),
    require('../img/lottery/card_show/41.png'),
    require('../img/lottery/card_show/42.png'),
    require('../img/lottery/card_show/43.png'),
    require('../img/lottery/card_show/44.png'),
    require('../img/lottery/card_show/45.png'),
    require('../img/lottery/card_show/46.png'),
    require('../img/lottery/card_show/47.png'),
    require('../img/lottery/card_show/48.png'),
    require('../img/lottery/card_show/49.png'),

    require('../img/lottery/card_show/50.png'),
    require('../img/lottery/card_show/51.png'),
    require('../img/lottery/card_show/52.png'),
    require('../img/lottery/card_show/53.png'),
    require('../img/lottery/card_show/54.png'),
    require('../img/lottery/card_show/55.png'),
    require('../img/lottery/card_show/56.png'),
    require('../img/lottery/card_show/57.png'),
    require('../img/lottery/card_show/58.png'),
    require('../img/lottery/card_show/59.png'),
]
var rule_button = require('./rule_button.vue')
module.exports = {
    components: {rule_button},
    data() {
        return {
            task  : [
                {task_id: 'task_1', val: 0, class: 'img_221', max_val: 1},
                {task_id: 'task_2', val: 0, class: 'img_17', max_val: 1},
                {task_id: 'task_3', val: 0, class: 'img_17', max_val: 2},
                {task_id: 'task_4', val: 0, class: 'img_17', max_val: 1, href: "https://weibo.com/u/7782998196"},
                {task_id: 'task_5', val: 0, class: 'img_17', max_val: 1},
                {task_id: 'task_6', val: 0, class: 'img_17', max_val: 5},
                {task_id: 'task_7', val: 0, class: 'img_17', max_val: 1},
            ],
            config: [
                {item_id: null, lock: true,},
                {item_id: null, lock: true,},
                {item_id: null, lock: true,},
            ],

            all_config: [],
            user      : null,
            now_data  : '',
            name      : {},
        }
    },
    computed: {},
    created() {


        this.name = this.conf_name
        this.user = this.user_data
        this.get_user_data()
        //
        setTimeout(() => {
            this.load_img()
        }, 3000)


    },
    methods: {
        init(){
            this.config.forEach(i=> {
                i.item_id = null
                i.lock= true
            })
            this.task.forEach(i=>i.val = 0)
            this.all_config = []

        },
        load_img() {
            img_list.forEach(src => {
                var img = new Image()
                img.src = src
            })
        },
        go_to_scroll(top_px) {
            this.$emit('go_to_scroll', top_px)
        },
        get_user_data() {
            if (!this.user_data.account) {
                return
            }
            this.$httpr.get_data((err, result) => {
                if (!result || !result.ok) {
                    return this.alter('err', (result && (result.err || result.msg)) || err)
                }
                this.set_user_data(result.data)
            })
        },
        set_user_data(data) {
            this.now_data = data.now_data
            data.task_5 = parseInt(data.task_5)
            data.task_3 = data.task_3 ? data.task_3.split(',') : [0, '', 0]
            data.task_1 = data.task_1 ? data.task_1.split(',') : [0, '', 0]
            data.task_1 = data.task_1[1] == data.now_data ? 1 : 0
            this.task_3_is_lock = data.task_3[1] == data.now_data
            this.task.forEach(i => i.val = parseInt((data[i.task_id] && data[i.task_id].length ? data[i.task_id][0] : data[i.task_id]) || 0))
            console.log('this.task',this.task,data)
            this.user.config_is_lock = data.config_is_lock == 1
            this.user.value = parseInt(data.value || 0)
            var now_config = (data.now_config || '').split(',')
            this.config.forEach((i, index) => {
                i.item_id = isNaN(parseInt(now_config[index])) ? '' : parseInt(now_config[index])
                i.lock = index >= data.config_add_number
            })

            this.user.a_tel_shave = data.a_tel_shave
            console.log('this.user', this.user)
        },
        get_account() {
            if (this.user.account) {
                return this.user.account
            }
            this.alter('login')
        },
        update_alter(item, key, new_role_list) {
            if (item && item.lock) {
                return
            }
            if (this.user.config_is_lock) {
                return this.alter('err', '已经锁定同行舱，无法进行更换')
            }
            var account = this.get_account()
            if (!account) {
                return
            }
            this.alter('knapsack', {item, key, config: this.config, new_role_list})

        },
        lock_config() {
            var account = this.get_account()
            if (!account) {
                return
            }
            this.alter('determine_config', {}, (type) => {
                if (type === 'ok') {
                    this.$httpr.determine_config((err, data) => {
                        if (err || data.err) {
                            return this.alter('err', err || data.err)
                        }
                        this.user.config_is_lock = true
                    })
                }
            })
        },
        go_task(item) {
            var account = this.get_account()
            var that = this
            if (!account) {
                return
            }
            console.log('item', item)
            // 任务完成

            // 任务今日已完成
            if (item.val) {

            }
            // 任务直接完成
            if (item.task_id === 'task_1') {
                return item.val >= item.max_val ? null : this.ok_task('1')
            }
            if (item.task_id === 'task_2') {
                return item.val >= item.max_val ? null : this.ok_task('2')
            }

            if (item.task_id === 'task_3') {
                return this.alter('shave_page', {that})
            }
            if (item.task_id === 'task_4') {
                this.ok_task('4')
                return setTimeout(function () {
                    window.open(item.href)
                }, 100)
            }
            if (item.task_id === 'task_5') {
                this.ok_task('5')
                return this.alter('weixin')
            }
            if (item.task_id === 'task_6') {
                return this.alter('shave_page', {that})
            }
            if (item.task_id === 'task_7' && item.val == 0) {
                console.log('item.val', item.val)
                return this.$alter_err.show_box('err', '任务条件未达成')
            }

        },
        ok_task(number) {
            var account = this.get_account()
            if (!account) {
                return
            }

            if (number == 3 && this.task_3_is_lock) {
                return
            }
            this.$httpr.ok_task(parseInt(number), (err, data) => {
                console.log('ok_task err', err, data)
                if (err || data.err) {
                    return this.$alter_err.show_box('err', data ? data.err : '网络异常')
                }

                data && data.ok && this.get_user_data()
            })
        },
        lottery(num) {
            var that = this
            var account = this.get_account()
            if (!account) {
                return
            }
            // test
            // return this.$alter.show_box('lottery', {items: [0,1,2,3,4], that: that}, null, {is_show_close: true})

            console.log('this.user_data', this.user_data)
            if (this.user_data.value < num) {
                // 跳转任务区域

                return this.alter('err', '抽奖次数不足\n完成任务获得更多抽奖次数吧！', () => this.go_to_scroll(3050))
            }
            console.log('this.user_data.value', this.user_data.value)
            this.$httpr.lottery(num, (err, result) => {
                console.log('lottery', err, result)
                err = err || result.msg || result.err
                if (err) {
                    return this.alter('err', err)
                }

                var data = result.data
                this.user.value = parseInt(data.value)
                console.log('data.item_ids', data.item_ids)
                this.$alter.show_box('lottery', {items: data.item_ids, that}, null, {is_show_close: true})
            })
        },
        alter(type, data, callback) {
            if (type === 'login') {
                callback = () => this.get_user_data()
            }
            this.$alter.show_box(type, data, callback)
        },
    },
}
</script>

<style scoped>
.move_button {
    position: absolute;
    bottom: 0.2rem;
    width: 100%;
    text-align: center;

}

.text {
    font-size: .24rem;
    color: #FBE9C8;
}

.inline {
    display: inline-block;
    margin: 0 0.3rem;
}

.move_button .center {
    margin: 0rem auto 0.1rem;
}

.ico_bg {
    position: relative;
    display: inline-block;
}

.lock {
    position: absolute;
    left: 50%;
    top: 3rem;
    transform: translate(-50%, -50%);
}

.ico_img {
    position: absolute;
    width: 100%;
    height: 100%;
}

.update_alter {
    position: absolute;
    bottom: -.3rem;
    left: .15rem;
}

.task_box {
    position: absolute;
    right: 0.6rem;
    top: 2.32rem;
}

.task_item {
    position: absolute;
    right: 0rem;
}

.task_item.task_1 {
    top: 0rem;
}

.task_item.task_2 {
    top: 1.96rem
}

.task_item.task_3 {
    top: 3.1rem
}

.task_item.task_4 {
    top: 4.55rem
}

.task_item.task_5 {
    top: 5.7rem
}

.task_item.task_6 {
    top: 6.9rem;
}

.task_item.task_7 {
    top: 9.5rem
}

.config_box {
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    text-align: center;
    top: 3rem;
}

.text_name {
    position: absolute;
    top: 2.3rem;
    text-align: center;
    transform: translate(0%, -50%);
    font-size: 0.24rem;
    width: 100%;
    /*width: 1.38rem;*/
}

.progressBar {
    margin-top: 0.1rem;
    color: #424345;
    text-align: center;
    font-size: 0.18rem;
}

.logo {
    position: absolute;
    right: 0.10rem;
    top: 0.10rem;
}

.left_bottom {
    position: absolute;
    left: -.1rem;
    top: 1.75rem;
    width: 1.4rem;
    height: .5rem;
    z-index: 2;
}
</style>